import { ApiType } from "@gymflow/common";
import { utcToZonedTime, zonedTimeToUtc } from "@gymflow/helpers";
import { ApiListResponse, VisitTotalReportDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { reportQueryKeys } from "./reportQueryKeys";

export interface UseQueryVisitTotalReportProps {
  api: ApiType;
  dateFrom?: string;
  dateTo?: string;
  sort?: any;
  page?: number;
  size?: number;
  tz: string;
}

export function useQueryVisitTotalReport(
  {
    api,
    dateFrom,
    dateTo,
    sort,
    page,
    size,
    tz,
  }: UseQueryVisitTotalReportProps,
  queryOpts?: Omit<
    UseQueryOptions<ApiListResponse<VisitTotalReportDTO>>,
    "queryKey"
  >,
) {
  const result = useQuery({
    queryKey: reportQueryKeys.visitTotal({
      dateFrom,
      dateTo,
      sort,
      page,
      size,
    }),
    queryFn: async () => {
      const result = await api.accessApi.visitTotalReport({
        dateFrom: zonedTimeToUtc(dateFrom as string, tz),
        dateTo: zonedTimeToUtc(dateTo as string, tz),
        sort,
        page,
        size,
      });
      return result.data;
    },
    select: (data) => {
      return {
        ...data,
        content: data.content.map(({ checkInDate, checkOutDate, ...rest }) => {
          return {
            ...rest,
            checkInDate: utcToZonedTime(checkInDate, tz),
            checkOutDate: checkOutDate && utcToZonedTime(checkOutDate, tz),
          };
        }),
      };
    },
    enabled: !!tz && !!dateFrom && !!dateTo,
    ...queryOpts,
  });
  return result;
}
